import { logWithSentry, SentryErrorKind } from 'scripts/initSentry';
import { captureException } from 'utils/captureException';

export function urlBase64ToUint8Array(base64String: string) {
  try {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    // eslint-disable-next-line no-useless-escape
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;
  } catch (e) {
    logWithSentry(e, SentryErrorKind.normalization);
    captureException(e);

    return '';
  }
}
